import React, { useEffect } from 'react';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container/src/index.tsx';
import { useEntryPoint } from '@atlassian/jira-entry-point/src/controllers/use-entry-point/index.tsx';
import { SingleLineSmartLinkEntryPoint } from './entrypoint.tsx';
import type { SingleLineSmartLinkProps } from './types.tsx';

const entryPointParams = {};

/**
 * @deprecated This component is deprecated as it does not support rendering in SSR out of the box, and follows
 * undesirable design patterns for VC performance by loading the component lazily on mount. Consumers should use
 * <SimpleInlineSmartLink /> instead.
 * TODO JSC-1512 Migrate LazySingleLineSmartLink usages to SimpleInlineSmartLink
 */
export const LazySingleLineSmartLink = (props: SingleLineSmartLinkProps): React.JSX.Element => {
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		SingleLineSmartLinkEntryPoint,
		entryPointParams,
	);

	// eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
	useEffect(() => {
		entryPointActions.load();
	}, [entryPointActions]);

	return (
		<JiraEntryPointContainer
			id="jira.issue-field.single-line-smart-link"
			packageName="issue-field-smart-link"
			entryPointReferenceSubject={entryPointReferenceSubject}
			runtimeProps={props}
		/>
	);
};
